import Icon from '@ant-design/icons/lib/components/Icon';
import {
  cardIcon,
  creditAmex,
  creditCardGeneral,
  creditCardVisa,
  creditMasterCard
} from '@tools/ui/assets';
import {
  CardAccount,
  CardAccount as CardAccounts,
  Maybe
} from '@tools/ui/types/generated/graphql';
import { TranslationCommon } from '@tools/ui-locales';
import { t } from './translate.util';

export enum CardNetwork {
  Visa = 'visa',
  Mastercard = 'mastercard',
  Amex = 'amex',
  Discover = 'discover',
  Debit = 'debit'
}

export const extractNetworkFromCard = (
  cardAccount?: Maybe<CardAccount>
): string | undefined => {
  const card = cardAccount || ({} as CardAccounts);
  return card.network?.toLowerCase();
};

interface NetworkConfig {
  icon: typeof Icon;
  tooltipKey: TranslationCommon;
}

const NETWORK_CONFIG: Record<string, NetworkConfig> = {
  [CardNetwork.Visa]: {
    icon: creditCardVisa as unknown as typeof Icon,
    tooltipKey: 'fundingSource.cardNetworkTooltip.visa'
  },
  [CardNetwork.Mastercard]: {
    icon: creditMasterCard as unknown as typeof Icon,
    tooltipKey: 'fundingSource.cardNetworkTooltip.mastercard'
  },
  [CardNetwork.Amex]: {
    icon: creditAmex as unknown as typeof Icon,
    tooltipKey: 'fundingSource.cardNetworkTooltip.amex'
  },
  [CardNetwork.Discover]: {
    icon: creditCardGeneral as unknown as typeof Icon,
    tooltipKey: 'fundingSource.cardNetworkTooltip.discover'
  },
  // debit card is not really a network, but some consumers still send it as such
  [CardNetwork.Debit]: {
    icon: cardIcon as unknown as typeof Icon,
    tooltipKey: 'fundingSource.cardNetworkTooltip.debit'
  }
};

export const buildIconAndNameFromNetwork = (
  network: string | undefined,
  tooltipText = '',
  cardType?: string
): { icon: typeof Icon; tooltip: string } => {
  const lcNetwork = network?.toLowerCase() ?? '';
  const cardTypeLabel = cardType ? `(${cardType})` : '';

  const matchedKey = Object.keys(NETWORK_CONFIG).find((key) =>
    lcNetwork.includes(key)
  );
  const config = matchedKey ? NETWORK_CONFIG[matchedKey] : undefined;
  const icon = config?.icon ?? (creditCardGeneral as unknown as typeof Icon);
  const tooltipKey = config?.tooltipKey;

  const baseLabel = tooltipKey ? t(tooltipKey) : network ?? '';
  const tooltip = [baseLabel, cardTypeLabel, tooltipText]
    .filter(Boolean)
    .join(' ');

  return { icon, tooltip };
};
